import { Injector } from "@angular/core";
import { Art57NodeList } from "../../Art57Node/Art57NodeList";
import { ListView } from "../../../Data/ListView";
import { PharmaceuticalFormAutoUploadEntity } from "../Entity/PharmaceuticalFormAutoUploadEntity";
import { BaseNode } from "../../BaseNode";
import { environment } from "../../../../../../environments/environment";


export class TreeNodeMedicinalProductAuthorisedPharmaceuticalForm extends Art57NodeList{

    items: any;
    cloningNode: boolean = false;
    useHist: boolean = false;
    constructor(injector: Injector, parent: any, useHist: boolean, items: any[]|undefined, cloningNode: boolean) {
        super(injector, new ListView(), `Authorised Pharmaceutical Forms (${items?items.length:'-'})`);
        this.parent = parent;
        this.items = items;
        this.cloningNode = cloningNode;
        this.useHist = useHist;
        this.labelNodeName = 'Authorised Pharmaceutical Forms'

        if (this.cloningNode) {
          return;
        }

        for (const item of items || []) {            
            const labelTemplate = `${item.name_Pharmform}`;
            this.children?.push(new PharmaceuticalFormAutoUploadEntity(injector,labelTemplate,this,item,this.useHist,true, this.cloningNode));
        }
    }

    override getHeaders(): string[] {
        return ['Pharmaceutical Form Name'];
    }

    override cloneNode(newParent: BaseNode): BaseNode|undefined {
      let clonedNode: TreeNodeMedicinalProductAuthorisedPharmaceuticalForm = new TreeNodeMedicinalProductAuthorisedPharmaceuticalForm(
        this.ioc!,
        newParent,
        this.useHist,
        this.items,
        true
      );
  
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

  
      this.children?.forEach((child) => {
        let childToClone = child as BaseNode;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
      
     clonedNode.cloningNode = false;
     return clonedNode;
    }

}